interface Params {
  isAuthenticated: boolean;
  totalMatches: number;
  totalExactMatches: number;
  itemsPerPage: number;
}

interface LoginPromptVisibility {
  showLoginInExactMatchList: boolean;
  showLoginInPossibleMatchList: boolean;
}

export const getLoginPromptVisibility = ({
  isAuthenticated,
  totalMatches,
  totalExactMatches,
  itemsPerPage,
}: Params): LoginPromptVisibility => {
  if (isAuthenticated || totalMatches <= itemsPerPage) {
    return {
      showLoginInExactMatchList: false,
      showLoginInPossibleMatchList: false,
    };
  }

  if (totalExactMatches >= itemsPerPage) {
    return {
      showLoginInExactMatchList: true,
      showLoginInPossibleMatchList: false,
    };
  }

  return {
    showLoginInExactMatchList: false,
    showLoginInPossibleMatchList: true,
  };
};
